import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { CAV6 } from '../../cav6tokens';
import { g } from '../../HomeScreen/HomeScreen.styles';

const DotsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: g(12),
  marginTop: g(26),
  pointerEvents: 'none',
});

const DOT = `max(7px, ${g(13)})`;

const Dot = styled(Box, { shouldForwardProp: (p) => p !== '$active' })<{ $active?: boolean }>(({ theme, $active }) => ({
  width: $active ? `calc(${DOT} * 2.8)` : DOT,
  height: DOT,
  borderRadius: CAV6.pillRadius,
  background: $active ? theme.palette.primary.main : 'rgba(0,0,0,.12)',
  transition: `width 260ms ${CAV6.easeOut}, background-color 260ms ${CAV6.easeOut}`,
}));

interface Props {
  count: number;
  activeIndex: number;
}

/** Step dots; the current one is a brand-color pill. */
export const ProgressDots: FC<Props> = ({ count, activeIndex }) => {
  return (
    <DotsContainer>
      {Array.from({ length: count }, (_, i) => (
        <Dot key={i} $active={i === activeIndex} />
      ))}
    </DotsContainer>
  );
};
